"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationHeader = void 0;
var _useRecommendationStatus = require("./useRecommendationStatus");
var _services = require("../../services");
var useRecommendationHeader = function useRecommendationHeader() {
  var _useRecommendationSta = (0, _useRecommendationStatus.useRecommendationStatus)(),
    isJourneyForHandsetAndPlan = _useRecommendationSta.isJourneyForHandsetAndPlan,
    isJourneyForHandset = _useRecommendationSta.isJourneyForHandset,
    isJourneyForPlan = _useRecommendationSta.isJourneyForPlan,
    isJourneyForBroadband = _useRecommendationSta.isJourneyForBroadband;
  var headerText;
  switch (true) {
    case isJourneyForHandsetAndPlan:
      headerText = _services.locale.localeString('Recommendation.HeaderPhoneAndPlan');
      break;
    case isJourneyForHandset:
      headerText = _services.locale.localeString('Recommendation.HeaderPhone');
      break;
    case isJourneyForPlan:
      headerText = _services.locale.localeString('Recommendation.HeaderPlan');
      break;
    case isJourneyForBroadband:
      headerText = _services.locale.localeString('Recommendation.HeaderBroadband');
  }
  return {
    headerText: headerText
  };
};
exports.useRecommendationHeader = useRecommendationHeader;